class DisclaimerSource {
	private element!: HTMLElement;

	constructor (id: string) {
		const element = document.getElementById(id) as HTMLElement;
		if (element === null) {
			throw Error(`[ExternalOptionsBuilder] No element was found with id ${id}`);
		}

		this.element = element;
	}

	public getHtml (): string {
		return this.element.innerHTML;
	}
}

export default new DisclaimerSource('disclaimer');
